import React, { Suspense } from "react";
import { colors } from "../../colors";

const LazyOffersLanding = React.lazy(() => import("./landing"));

export const OffersLandingRouter = () => {
  return (
    <Suspense
      fallback={<div style={{ width: "100vw", height: "100vh", backgroundColor: colors.memberBg }}></div>}
    >
      <LazyOffersLanding />
    </Suspense>
  );
};
